<template>
  <div class="page-dialog">
    <div v-if="show" class="mask"></div>
    <div class="dialog-box" v-if="show">
      <div class="dialog-content">
        <slot name="title">
          <p class="content-title">{{title}}</p>
        </slot>
        <slot name="content">
          <p class="content-subtext">{{content}}</p>
        </slot>
      </div>
      <div class="dialog-footer">
        <div class="footer-btn cancel"
             v-if="!single"
             @click="secondaryClicked">
          <p class="btn-text" :style="{ color: secondBtnColor }">{{cancelText}}</p>
        </div>
        <div class="footer-btn confirm" @click="primaryClicked">
          <p class="btn-text" :style="{ color: mainBtnColor }">{{confirmText}}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      show: {
        type: Boolean,
        default: false
      },
      single: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: ''
      },
      content: {
        type: String,
        default: ''
      },
      cancelText: {
        type: String,
        default: '取消'
      },
      confirmText: {
        type: String,
        default: '确定'
      },
      mainBtnColor: {
        type: String,
        default: '#007aff'
      },
      secondBtnColor: {
        type: String,
        default: '#007aff'
      },
    },
    methods: {
      secondaryClicked () {
        this.$emit('cancelBtnClicked', {
          type: 'cancel'
        });
      },
      primaryClicked () {
        this.$emit('confirmBtnClicked', {
          type: 'confirm'
        });
      },
    }
  };
</script>

<style scoped>
  .page-dialog {
    position: fixed;
    width: 750px;
    /*兼容H5异常*/
    z-index: 99999;
  }

  .mask {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9;
    width: 100%;
    height: 100%;
    background:rgba(0,0,0,0.3);
  }

  .dialog-box {
    position: fixed;
    top: 520px;
    left: 50%;
    margin-left: -279px;
    width: 558px;
    background-color: rgba(247,247,247,0.96);
    border-radius: 30px;
    z-index: 9;
  }

  .dialog-content {
    padding-top: 43px;
    padding-bottom: 43px;
    padding-left: 22px;
    padding-right: 22px;
  }

  .content-title {
    color: #000000;
    font-size: 34px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 12px;
  }

  .content-subtext {
    color: #000000;
    font-size: 26px;
    line-height: 36px;
    text-align: center;
  }

  .dialog-footer {
    display: flex;
    flex-direction: row;
    align-items: center;
    border-top-color: rgba(9,20,31,0.13);
    border-top-width: 1px;
  }

  .footer-btn {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex: 1;
    height: 90px;
  }

  .cancel {
    border-right-color: rgba(9,20,31,0.13);
    border-right-width: 1px;
  }

  .btn-text {
    font-size: 34px;
    color: #007aff;
  }
</style>
